import PvcImportImageForm from '../components/pvc-import-image-form/pvc-import-image-form';

ManageIQ.component.addReact('PvcImportImageForm', PvcImportImageForm);